import { Injectable } from "@angular/core";
import { ResourceService } from "./resource.service";
import { HttpClient } from "@angular/common/http";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { Observable } from "rxjs";
import { UserModel } from "../model/user.model";
import { UserPasswordModel } from "../model/user-password.model";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SecurityService extends ResourceService<UserModel> {

  httpClient: HttpClient;
  globalSettings: GlobalSettings;
  constructor(
    http: HttpClient,
    settings: GlobalSettings,
    authService: AuthenticationService) {
    super(http, "", settings.securityApiUrl, authService)

    this.httpClient = http;
    this.globalSettings = settings;
  }

  createUserAccess(accessCode: string, userName: string): Observable<any> {
    return this.postWithComplement(`PolicyToken/${accessCode}?userName=${userName}`, {})
  }

  saveUser(model: UserModel, passwordExpirationDays?: number, passwordTimesLeft?: number): Observable<UserModel> {
    if (model.id) {
      return this.patchWithComplement(`Users/${model.id}`, model)
    } else {
      let query = "?generateDefaultPassword=true&sendInvitationEmail=true"

      if (passwordExpirationDays) {
        query += `&${passwordExpirationDays}`
      }

      if (passwordTimesLeft) {
        query += `&${passwordTimesLeft}`
      }

      return this.postWithComplement(`Users/${query}`, model)
    }
  }

  requestPasswordChange(userName: string): Observable<any> {
    var model: UserPasswordModel = new UserPasswordModel(userName);
    model.isChangeRequest = true;
    
    return this.httpClient.patch<any>(`${this.globalSettings.securityApiUrl}/Users/Passwords`,
      model,
      {
        headers: this.headers
          .set("Content-Type", "application/json")
          .set("env", environment.name)
      })
  }

  deleteUser(resourceId: string): Observable<UserModel> {
    return this.deleteWithComplement("Users", resourceId);
  }
}